"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhoneNumber = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
function validatePhoneNumber(inputPhoneNumber, allowEmptyStringNullUndefined = false) {
    if (!inputPhoneNumber) {
        return allowEmptyStringNullUndefined ? undefined : "EMPTY_PHONE_NUMBER";
    }
    if (typeof inputPhoneNumber !== "string") {
        return "PHONE_NUMBER_SHOULD_BE_STRING";
    }
    const startsWithPlus = inputPhoneNumber.startsWith("+");
    if (!startsWithPlus) {
        return "PHONE_NUMBER_SHOULD_START_WITH_PLUS";
    }
    const lengthValidation = (0, libphonenumber_js_1.validatePhoneNumberLength)(inputPhoneNumber);
    if (lengthValidation) {
        return lengthValidation;
    }
    const countryValidation = (0, libphonenumber_js_1.parsePhoneNumberFromString)(inputPhoneNumber);
    if (!countryValidation || !countryValidation.country) {
        return "INVALID_PHONE_NUMBER";
    }
    const isValid = (0, libphonenumber_js_1.isValidPhoneNumber)(inputPhoneNumber);
    if (!isValid) {
        return "INVALID_PHONE_NUMBER";
    }
}
exports.validatePhoneNumber = validatePhoneNumber;
//# sourceMappingURL=validatePhoneNumber.js.map